<template>
	<div>

		<div class="d-flex justify-content-between align-items-baseline">

			<h4>Custom Fields</h4>

			<button type="button" class="btn btn-success btn-sm" v-on:click="openEditModal(false)">
				<i class="fa fa-plus"></i>
				New Custom Field
			</button>

		</div>

		<p v-if="localCustomFields.length == 0" class="mt-2">
			Add some custom fields to track the information you want
		</p>

		<ul class="list-group mb-2">
			<draggable v-model="localCustomFields">

				<li v-for="(field,index) in localCustomFields" class="list-group-item d-flex flex-row justify-content-between align-items-center">

					<div>
						<i class="fa fa-sort mr-4"></i>
						<span class="">
							{{field.label}}
							<small class="ml-2">
								({{field.type}}) <span v-if="field.required">(required)</span>
							</small>
						</span>
					</div>

					<div>
						<button class="btn btn-sm btn-light mr-2" type="button" v-on:click="openEditModal(field)">
							<i class="fa fa-pencil-alt"></i>
						</button>
						<button class="btn btn-sm btn-outline-danger" type="button" v-on:click="openConfirmModal(index)">
							<i class="fa fa-trash"></i>
						</button>
					</div>
				</li>

			</draggable>
		</ul>

		<modal-dialog
			:modal-visible="editModal.visible"
			:title="editModal.title"
			v-on:closeModal="editModal.visible = false"
			v-on:confirm="saveField">

			<!---- Field Label ---->
			<field v-model="editModal.payload.label" label="Label" col-class="col-3" :params="{placeholder:'Label',required:true}"></field>

			<!---- Type Options ---->
			<field v-model="editModal.payload.type" label="Type" col-class="col-3" :params="{type:'select',options:typeOptions,required:true}"></field>

			<!---- Select Options, if applicable ---->
			<field v-if="editModal.payload.type == 'select'" label="Options" col-class="col-3" v-model="editModal.payload.options" >
				<p class="text-muted">To create a drop-down list, separate options by commas (ex. Morning,Daytime,Evening)</p>
			</field>

			<!---- Is Required? ---->
			<field v-model="editModal.payload.required" label="Required" col-class="col-3" :params="{type:'boolean'}"></field>

			<!---- Show on Company Form? ---->
			<field v-model="editModal.payload.showOnCompanyForm" label="Show Field on Company Form" col-class="col-6" :params="{type:'boolean'}"></field>

		</modal-dialog>

		<modal-dialog
			title="Delete Custom Field"
			:modal-visible="confirmModal.visible"
			confirm-button-text="Delete"
			button-class="btn-outline-danger"
			v-on:confirm="removeField"
			v-on:closeModal="confirmModal.visible = false">

			Are you sure you want to delete this custom field?

		</modal-dialog>

	</div>
</template>
<script type="text/javascript">
import ModalDialog from "../ModalDialog"
import Field from "../Field"
import FormGroup from "../FormGroup"
import draggable from "vuedraggable"

export default {
	name: "CustomFieldsList",
	components: {
		ModalDialog,
		Field,
		FormGroup,
		draggable,
	},
	props: [
		"customFields"
	],
	data() {
		return {
			localCustomFields: null,

			editModal: {
				title: "",
				visible: false,
				record: null,
				payload: {}
			},

			confirmModal: {
				visible: false,
				index: -1
			},

			typeOptions: [
				{text: 'Text',value:'text'},
				{text: 'Date',value:'date'},
				{text: 'Number',value:'number'},
				{text: 'Province/State',value:'province'},
				{text: 'Select',value:'select'},
				{text: 'Boolean',value:'boolean'}
			]
		}
	},
	watch: {
		customFields() {
			if (this.customFields)
				this.localCustomFields = this.cloneObj(this.customFields)
		}
	},
	computed: {

	},
	methods: {
		fieldChange() {
			this.$emit('change', this.localCustomFields)
		},

		saveField() {

			let errors = []
			if (!this.editModal.payload.label)
				errors.push("Label is required")

			if (!this.editModal.payload.type)
				errors.push("Type is required")

			if (this.editModal.payload.type == 'select' && !this.editModal.payload.options)
				errors.push("Select types must have a list of options")

			if (errors.length == 0) {

				if (this.editModal.record) {   // Existing field

					Object.keys(this.editModal.record).forEach(key => {
						if (key in this.editModal.payload)
							this.editModal.record[key] = this.editModal.payload[key]
						else
							delete this.editModal.record[key]
					})


				} else {   // New field
					this.editModal.record = this.editModal.payload
					this.localCustomFields.push(this.editModal.record)
				}

				this.editModal.record.order = this.localCustomFields.length
				this.editModal.visible = false
				this.fieldChange()
			}
			else
				this.alertErrors(errors)

		},

		removeField() {
			this.localCustomFields.splice(this.confirmModal.index, 1)
			this.confirmModal.visible = false
			this.fieldChange()
		},

		openConfirmModal(index) {
			this.confirmModal.index = index
			this.confirmModal.visible = true
		},

		openEditModal(field) {

			if (field) {  // Existing field
				this.editModal.title = "Edit Custom Field"
				this.editModal.record = field
				this.editModal.payload = this.cloneObj(field)

			} else {      // New field
				this.editModal.title = "New Custom Field"
				this.editModal.record = null
				this.editModal.payload = {
					type: '',
					label: '',
					required: false,
					showOnCompanyForm: false
				}
			}

			this.editModal.visible = true
		},
	},
	created() {
		if (this.customFields)
			this.localCustomFields = this.cloneObj(this.customFields)
	}
}
</script>